import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6275cc28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrapper",
  role: "button"
}
const _hoisted_2 = ["id", "data-bs-target"]
const _hoisted_3 = {
  key: 0,
  class: "task-card__body__cover"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "bi bi-pencil task-card__body__editicon" }
const _hoisted_6 = { class: "task-card__body__details d-flex flex-column gap-1 px-2 py-1" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-wrap gap-1 justify-content-start align-items-center"
}
const _hoisted_8 = { class: "task-card__body__title card-title d-flex justify-content-between align-items-center text-break" }
const _hoisted_9 = { class: "task-card__body__details d-flex flex-wrap gap-2 justify-content-start align-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "task-card__body__details__date bg-warning rounded-1 text-white d-flex gap-1 justify-content-start align-items-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "task-card__body__details__description d-flex gap-1 justify-content-start align-items-center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-justify-left" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "task-card__body__details__comments d-flex gap-1 justify-content-start align-items-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat" }, null, -1))
const _hoisted_17 = {
  key: 3,
  class: "task-card__body__details__attachments d-flex gap-1 justify-content-start align-items-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1))
const _hoisted_19 = {
  key: 4,
  class: "task-card__body__details__members d-flex ms-auto gap-1 justify-content-start align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kanban_task_label = _resolveComponent("kanban-task-label")!
  const _component_avatar_group = _resolveComponent("avatar-group")!
  const _component_kanban_task_modal = _resolveComponent("kanban-task-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: _ctx.task._id,
      class: "task-card card",
      draggable: "true",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_ctx.task.task[0]}${_ctx.task._id}`,
      onDragstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDragStart && _ctx.handleDragStart(...args))),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = true))
    }, [
      _createElementVNode("div", {
        class: "task-card__body card-body rounded-2 p-0",
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEditIcon = true)),
        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditIcon = false))
      }, [
        (_ctx.cover)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                draggable: "false",
                src: `${_ctx.$STATIC_URL}/${_ctx.cover.name}`,
                class: "img-fluid rounded-top",
                alt: "board"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
          [_vShow, _ctx.showEditIcon]
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.taskLabels.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskLabels, (label) => {
                  return (_openBlock(), _createBlock(_component_kanban_task_label, {
                    key: label._id,
                    text: label.text,
                    color: label.color,
                    "custom-styles": {
                height: '8px',
                minWidth: '40px'
              }
                  }, null, 8, ["text", "color"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.task.task), 1),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.task.date.dueDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.task.date.dueDate)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.task.description.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
            (_ctx.task.comments.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(_ctx.task.comments.length), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.task.attachments.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", null, _toDisplayString(_ctx.task.attachments.length), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.task.members.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_avatar_group, {
                    members: _ctx.taskMembers,
                    size: "small"
                  }, null, 8, ["members"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 32)
    ], 40, _hoisted_2),
    _createVNode(_component_kanban_task_modal, {
      show: _ctx.showModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = false))
    }, null, 8, ["show"])
  ]))
}